// extracted by mini-css-extract-plugin
export default {"h1":"Text_h1__s39rN","h2":"Text_h2__9qP5J","h3":"Text_h3__l20a8","p":"Text_p__w-WRz","span":"Text_span__F1-Gj"};